<template>
    
    <div>

		<OpeningPanel
			:infoPanel="dashboardType === 'rank-tracking'"
			class="opening-panel"
		>
			<template v-slot:title>
				<h1 v-html="openingPanelHeader" :class="{'opening-panel-header': dashboardType === 'all'}" />
			</template>
			<template v-slot:content>
				<div class="opening-panel-content-inner">
					<div :class="{'opening-panel-content': true}" v-if="dashboardType === 'all'">
						<p :class="{'opening-panel-text':true, full: dashboardType !== 'rank-tracking'}">
							<strong>Need some help with using RankCaddy?</strong> <br v-if="dashboardType === 'rank-tracking'">Find all our <a href="#" @click="setShowVideos">instructional videos here</a>. 
							<span v-if="keywordCountIssue" class="red"><br><strong>{{keywordCountIssue}}</strong></span><br>
							<span :class="{'large-button':true, pulse:noProjects}" @click="newProject()" v-html="addNewButtonLabel" v-if="addNewButtonLabel" />
						</p>
						<img src="./../assets/img/mascot.png" alt="" class="dashboard-info-img">
					</div>
					<p :class="{'opening-panel-text':true, full: dashboardType !== 'rank-tracking'}" v-if="dashboardType !== 'all'">
						<strong>Need some help with using RankCaddy?</strong> <br v-if="dashboardType === 'rank-tracking'">Find all our <a href="#" @click="setShowVideos">instructional videos here</a>. 
						<span v-if="keywordCountIssue" class="red"><br><strong>{{keywordCountIssue}}</strong></span><br>
						<span :class="{'large-button':true, pulse:noProjects}" @click="newProject()" v-html="addNewButtonLabel" v-if="addNewButtonLabel" />
					</p>
					<div class="opening-overview" v-if="breakdown.length>0&&dashboardType === 'rank-tracking'">
						<div 
							:class="{'number-total-wrap':true,'small-lr':breakdown.length>5}"
							v-for="(b, bIndex) in breakdown" 
							:key="'breakdown-'+bIndex"
						>
							<NumberTotalDoughnut
								donutSize="small"
								:total="b.count"
								:label="b.label" 
								:noBottom="true"
								:noTop="true"
								:class="{doughnut:true,noCount:false,doughnut:true}"
							/>
						</div>
					</div>
				</div>
			</template>
		</OpeningPanel>

		<section class="outer-pad" v-if="dashboardType!=='all'">

			<div :class="{'search-toggle-view':true, 'has-toggle': showViewToggle, faded: init}" v-if="!noProjects">

				<div :class="{'search-toggle-view-inner':true}">

					<div class="search-toggle-view-search">

						<FormInput 
							type="text" 
							v-model="searchText"  
							name="searchText" 
							:placeholder="dashboardType === 'data-dive' ? 'Search for a domain' : 'Search projects by name/domain'"
							:noMarginBottom="true"
							:required="false"
							:inline="true"
							class="form-input-search"
							@aKeyup.enter="searchBox"
							@aKeyup.esc="clearSearch"
						/>

						<font-awesome-icon icon="search" class="mag" :style="{ color: '#3b445b' }" @click="searchBox" />

						<span class="clear" v-if="!!searchText" @click="clearSearch">reset</span>

						<Switcher 
							:sameColour="true" 
							v-model="showPaused" 
							:switcherLabel2="'Show paused projects'"
							class="paused-switcher" 
							v-if="dashboardType==='rank-tracking'&&table.hiddenCount>0"
						/>

					</div>

					<div :class="{'search-toggle-view-toggle':true, hasProjects:!noProjects}">

						<svg v-if="showViewToggle" xmlns="http://www.w3.org/2000/svg" @click="setView('table')" viewBox="0 0 25.51 25.52" :class="{selected:view==='table'}"><rect class="cls-1" width="25.51" height="3.9" rx="1.93" ry="1.93"/><rect class="cls-1" y="7.21" width="25.51" height="3.9" rx="1.93" ry="1.93"/><rect class="cls-1" y="14.42" width="25.51" height="3.9" rx="1.93" ry="1.93"/><rect class="cls-1" y="21.62" width="25.51" height="3.9" rx="1.93" ry="1.93"/></svg><svg v-if="showViewToggle" :class="{selected:view==='tiles'}" @click="setView('tiles')" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.52 25.52"><path d="m9.51,11.76H2.26c-1.25,0-2.26-1.01-2.26-2.26h0V2.25C0,1.01,1.02,0,2.26,0h7.25c1.24,0,2.25,1.01,2.25,2.25v7.25c0,1.24-1.01,2.25-2.25,2.26Z"/><path class="cls-1" d="m23.26,11.76h-7.25c-1.24,0-2.25-1.02-2.25-2.26V2.25c0-1.24,1.01-2.25,2.25-2.25h7.25c1.24,0,2.25,1.01,2.26,2.25v7.25c0,1.25-1.01,2.26-2.26,2.26Z"/><path class="cls-1" d="m9.51,25.52H2.26c-1.24,0-2.25-1.01-2.26-2.25v-7.25c0-1.25,1.01-2.26,2.26-2.26h7.25c1.24,0,2.25,1.02,2.25,2.26v7.25c0,1.24-1.01,2.25-2.25,2.25Z"/><path class="cls-1" d="m23.26,25.52h-7.25c-1.24,0-2.25-1.01-2.25-2.25v-7.25c0-1.24,1.01-2.25,2.25-2.26h7.25c1.25,0,2.26,1.01,2.26,2.26v7.25c0,1.24-1.02,2.25-2.26,2.25Z"/></svg>

						<span 
							:class="{'large-button':true, mini:!noProjects, pulse:noProjects}"
							@click="newProject()"
							v-if="noProjects&&fullAccess"
							v-html="noProjects?(isDataDive?'Add a domain to get started' : 'Create a project to get started'):addNewButtonLabel"
						/>

					</div>

				</div>

			</div>

			<div v-if="upToSpeedVideo.show" class="video-thumb-container" @click="playVideo(upToSpeedVideo.slug)">

				<h3>{{upToSpeedVideo.title}}</h3>
				
				<img :src="upToSpeedVideo.img" alt="" class="">

			</div>

		</section>

		<section class="outer-pad padding-top" v-if="dashboardType==='all'">

			<div class="info-panel">

				<div class="dashboard-action-panels">
					<div class="dashboard-action-panel" @click="newProject('rank-tracking')">
						<div class="svg-circle-wrapper">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
								class="lucide lucide-plus h-8 w-8 text-white">
								<path d="M5 12h14"></path>
								<path d="M12 5v14"></path>
							</svg>
						</div>
						<h3>
							{{addNewButtonLabel}}
						</h3>
						<p>
							Create a new project for rank tracking.
						</p>
						<span class="large-button">
							Add
						</span>
					</div>
					<div v-if="!hasRankTracking" class="dashboard-action-panel video-panel" @click="playVideo(upToSpeedVideos['rank-tracking'].slug)">
						<div class="svg-circle-wrapper">
							<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-play-circle h-8 w-8 text-white"><circle cx="12" cy="12" r="10"/><polygon points="10 8 16 12 10 16 10 8"/></svg>
						</div>
						<h3 class="dashboard-action-panel-title">Watch our quick video to get started with rank tracking</h3>
						<img :src="upToSpeedVideos['rank-tracking'].img" alt="Get started video" style="width: 100%; max-width: 220px; margin: 10px auto; border-radius: 6px; box-shadow: 0 2px 8px rgba(0,0,0,0.07);" />
					</div>
					<div v-else class="dashboard-action-panel" @click="goToRankTracking">
						<div class="svg-circle-wrapper">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
								class="lucide lucide-chart-line h-6 w-6 text-white">
								<path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
								<path d="m19 9-5 5-4-4-3 3"></path>
							</svg>
						</div>
						<h3 class="dashboard-action-panel-title">
							View your rankings
						</h3>
						<p class="dashboard-action-panel-description">
							Check your current keyword rankings
						</p>
						<span class="large-button">
							View
						</span>
					</div>
					<div class="dashboard-action-panel" @click="newProject('data-dive')">
						<div class="svg-circle-wrapper">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
								class="lucide lucide-search h-8 w-8 text-white">
								<circle cx="11" cy="11" r="8"></circle>
								<path d="m21 21-4.3-4.3"></path>
							</svg>
						</div>
						<h3>
							Add a domain to Data Dive
						</h3>
						<p>
							Analyse a domain's Google Search Console &amp; Analytics data
						</p>
						<span class="large-button">
							Start
						</span>
					</div>
				</div>
			</div>

		</section>

		<section class="outer-pad" v-if="dashboardType==='all'">

			<SeoUpdateBar />

			<h2 class="dashboard-title">Want to sharpen your SEO skills?</h2>

			<SeoSkillsPanel />

		</section>

		<section class="outer-pad" v-if="theView==='table'&&!noProjects&&dashboardType!=='all'">

			<div v-if="ddButtons.length>0" class="graph-type-buttons-container">
				<h3 class="graph-type-title">7 Day Graph Type</h3>
				<div class="graph-type-buttons">
					<span 
						v-for="button in ddButtons" 
						:key="button._id"
						:class="['graph-type-button', { active: graphType === button._id }]"
						:style="{ 'color': graphType === button._id ? 'white' : button.styles.color, 'background-color': graphType === button._id ? button.styles.color : null, 'border-color': graphType === button._id ? button.styles.color : null }"
						@click="graphType = button._id"
					>
						{{button.label}}
					</span>
				</div>
			</div>

			<Table 
				:headings="tableHeadings" 
				:items="tableItems.items" 
				:pages="table.pages"
				:page="table.page"
				:count="table.count"
				:name="'dashboard-projects-'+dashboardType"
				@pagination="pagination"
				@deletePause="deletePause"
				@duplicate="duplicate"
				@setUp="setupProjectType"
				@clickedGraph="clickedGraph"
				@goTo="goTo"
				:emptyLabel="emptyLabel"
				:addNewButtonLabel="addNewButtonLabel"
				:loading="table.loading"
				:loadingText="table.loadingText"
				@addNew="newProject"
			/>

		</section>

		<ProjectSetup 
			v-if="showProjectSetup" 
			:copyFrom="copyFrom"
			@close="closeProjectSetup"
			@loadProjects="loadProjectsLocal"
			:projectInfo="setupProjectTypeMeta.projectInfo"
			:updateType="setupProjectTypeMeta.type"
			:enabled="enabled"
		/>

    </div>

</template>

<script>
import Vue from 'vue';
import { mapState, mapMutations, mapActions } from 'vuex'
import ApiService from './../services/api.service'
import { TokenService } from './../services/storage.service'
import Table from './../components/Table.vue'
import FormInput from './../components/Form/Input.vue'
import ProjectSetup from './../components/ProjectSetup.vue'
import TableIcon from './../components/Display/TableIcon.vue'
import TableButton from './../components/Display/TableButton.vue'
import Device from './../components/Display/Device.vue'
import KeywordCount from './../components/Display/KeywordCount.vue'
import RankUpDown from './../components/Display/RankUpDown.vue'
import LinkWithIcon from './../components/Display/LinkWithIcon.vue'
import OpeningPanel from './../components/Display/OpeningPanel.vue'
import ProjectTiles from './../components/Display/ProjectTiles.vue'
import TableHeadingWithIcon from './../components/Display/TableHeadingWithIcon.vue'
import TableStats from './../components/Display/TableStats.vue'
import TableImage from './../components/Display/TableImage.vue'
import Icon from './../components/Display/Icon.vue'
import NumberTotalDoughnut from './../components/Data/NumberTotalDoughnut.vue'
import Switcher from './../components/Switcher.vue'
import SeoSkillsPanel from './../components/Display/SeoSkillsPanel.vue'
import SeoUpdateBar from './../components/Display/SeoUpdateBar.vue'
import general from "./../utils/general";
export default {
  	name: 'Dashboard',
  	props: {},
  	components: { Table, FormInput, ProjectSetup, Device, KeywordCount, LinkWithIcon, OpeningPanel, NumberTotalDoughnut, ProjectTiles, Icon, Switcher, SeoSkillsPanel, SeoUpdateBar },
  	data() {

		return {
			lastUpdated: new Date().getTime(),
			lastChanged: new Date().getTime(),
			userFirstName: null,
			lastUpdatedData: null,
			adding: false, 
			errors: {},
			current:{},
			address:'',
			showProjectSetup: false,
			totals: {},
			table: {
				count: 0,
				hiddenCount: 0
			},
			loading: true,
			copyFrom: {},
			breakdown: {},
			searchText: '',
			view: 'table',
			reloadTimeout: {},
			setupProjectTypeMeta: {
				type: null,
				projectInfo: null
			},
			showPaused: false,
			init: true,
			projectCount: 0,
			enabled: {},
			dashboardUpdates: [],
			graphType: '',
			ddButtons: []
		}

	},
	computed: {

		...mapState('general',['dateTimeFormat','projectListLoaded','userInfo','projectList']),

		tableItems () {

			let items = { items: [], buttons: [], graphType: this.graphType };

			if ( this.dashboardType === 'data-dive' ) {

				if ( !this.table.items ) return items;

				this.table.items.forEach( function (item) {

					let item2 = general.stripObject(item);

					if ( !!item.graph ) {

						if ( !this.ddButtons.length ) {

							Object.keys(item.graph.values).forEach(
								function(fieldName,index) {
									if ( index === 0 ) this.graphType = fieldName;
									this.ddButtons.push({
										_id: fieldName,
										label: item.graph.values[fieldName].label,
										styles: {
											color: item.graph.values[fieldName].colour
										}
									});
								}.bind(this)
							);

						}

						let items = item.graph.values[this.graphType].values.reverse(), 
							data = [],
							hasValues = false;

						items.forEach(function(item,index) {
							let remaining = items.length - index;
							if ( data.length < 7 && ( data.length > 0 || item !== null || remaining <= 7 ) ) data.push(item);
							hasValues = hasValues || item !== null;
						});
						
						if ( hasValues ) {

							item2.graphInfo = { click: true, _id: item._id, src: 'https://quickchart.io/chart?c=' + encodeURIComponent(JSON.stringify({
								type: 'line',
								width: 1000,
								height: 500,
								data: {
									labels: ['', '', '', '', '', '', ''],
									datasets: [
										{
											label: '',
											lineTension: 0.4,
											backgroundColor: item.graph.values[this.graphType].colour,
											borderColor: item.graph.values[this.graphType].colour,
											borderWidth: 8,
											fill: false,
											data: data.reverse(),
											spanGaps: false
										}
									],
								},
								options: {
									width: 1000,
									height: 500,
									legend: {
										display: false,
									},
									layout: {
										padding: {
											left: 20,
											right: 20,
											top: 20,
											bottom: 20
										}
									},
									scales: {
									x: {
										display: false,
										grid: {
											display: true,
										},
										ticks: {
											beginAtZero: true,
											autoSkip: true,
											maxTicksLimit: 20,
											reverse: item.graph.values[this.graphType].reverse,
											precision: 0
										}
									},
									y: {
										display: true,
										grid: {
											display: true,
										},
										ticks: {
											display: false,
										}
									}
									},
								},
							})), styles: { width: '100px' } }

						}

					}
					
					items.items.push(item2);

				}.bind(this));

				return items;

			}
			
			return this.table.items ? this.table : { items: [] };

		},

		addNewButtonLabel () {

			const label =  this.dashboardType === 'data-dive' ? 'Add a new domain' : 'New Rank Tracking project';

			return this.fullAccess ? label : '';

		},

		upToSpeedVideos () {

			return {
				'rank-tracking': {
					slug: 'rank-tracking',
					title: 'Get up to speed on Rank Tracking...',
					img: require('./../assets/img/video-thumbs/rank-tracking.jpg')
				},
				'data-dive': {
					slug: 'data-dive',
					title: 'Get up to speed on Data Dive...',
					img: require('./../assets/img/video-thumbs/data-dive.jpg')
				}
			}

		},

		upToSpeedVideo () {

			if ( this.dashboardType === 'all' ) {

				return {
					show: false
				}

			}

			return this.upToSpeedVideos[this.dashboardType];

		},

		readyOnly () {

			return this.userInfo.access === 'read-only';

		},

		fullAccess () {

			return this.userInfo.access === 'full-access';

		},

		noProjects () {

			return this.projectCount === 0 && !this.init;

		},

		hasRankTracking () {

			return !!this.projectList.find(p => !!p.hasRankTracking);

		},

		hasDataDive () {

			return !!this.projectList.find(p => !!p.hasDataDive);

		},

		keywordCountIssue () {

			if ( !!this.userInfo.isShared ) return '';

			if ( this.dashboardType === 'data-dive' ) return '';

			let allocation = this.totals.subscriptionAllocation + this.totals.freeAllocation;

			if ( !!this.totals.activeKeywords && this.totals.activeKeywords > allocation ) {

				let s = this.totals.activeKeywords === 1 ? '' : 's';

				if ( allocation === 0 ) {

					return `You are currently tracking ${this.totals.activeKeywords} keyword${s} which is more than your daily quota, some will not be tracked!`;

				}

				return `You are currently tracking ${this.totals.activeKeywords} keyword${s} which is more than your daily quota of ${allocation}!`;

			}

		},

		emptyLabel () {

			switch ( this.dashboardType ) {

				case 'rank-tracking' :
					return 'You haven\'t created any Rank Tracking projects yet'

				case 'data-dive' :
					return 'You haven\'t created any Data Dive projects yet'

				default: 
					return 'You haven\'t created any projects yet'

			}

		},

		theView () {

			return this.showViewToggle ? this.view : 'table';

		},

		showViewToggle () {

			return this.dashboardType === 'all' && this.table.count > 0;

		},

		dashboardType () {

			switch ( this.$route.name ) {

				case 'dashboard' :
					return 'all';

				case 'dashboard-rank-tracking' :
					return 'rank-tracking';

				case 'dashboard-data-dive' :
					return 'data-dive';

			}

		},

		openingPanelHeader () {

			switch ( this.dashboardType ) {

				case 'rank-tracking' :
					return 'Your Rank Tracking projects';

				case 'data-dive' :
					return 'Your Data Dive domains';

				default: 

					let sessionInfo = TokenService.getExtraInfo();

					let c = ( sessionInfo && sessionInfo.created ) ? new Date(sessionInfo.created) : null;

					if ( this.userFirstName ) {
						if ( c && ( new Date().getTime() - c.getTime() ) < 180000 ) 
							return 'Welcome to RankCaddy ' + this.userFirstName + ' :)';
						return 'Welcome back ' + this.userFirstName + ' :)';
					}
					return 'Welcome To RankCaddy :)';

			}

		},

		projectOrDomain () {

			if ( this.dashboardType === 'data-dive' ) return 'domain';

			return 'project';

		},

		tableHeadings () {

			switch ( this.dashboardType ) {

				case 'all' :
					return {
						name: { value: 'Project' },
						url: { value: 'Domain', component: LinkWithIcon },
						locationName: { value: 'Location', mobileShowMoreOnly: true },
						dataDive: { value: 'Data Dive', mobileShowMoreOnly: true, headingComponent: TableHeadingWithIcon, component: TableStats, event: 'setUp', 'clickVars': ['_id','theType'] },
						rankTracking: { value: 'Rank Tracking', mobileShowMoreOnly: true, headingComponent: TableHeadingWithIcon, headingComponentSettings: { icon: 'rankTracking' }, component: TableStats, event: 'setUp', 'clickVars': ['_id','theType'] },
						contentKeywords: { value: 'Content & Keywords', mobileShowMoreOnly: true, headingComponent: TableHeadingWithIcon, component: TableStats, event: 'setUp', 'clickVars': ['_id','theType'] },
						weeklyInsights: { value: 'Weekly Insights', mobileShowMoreOnly: true, headingComponent: TableHeadingWithIcon, component: TableStats },
						duplicate: { value: '', component: TableIcon, event: 'duplicate', hideHeadingMobile: true, mobileClass: ['third'], mobileShowMoreOnly: true, valueForFilter: 'Duplicate' }
					};

				case 'data-dive' :
					return {
						url: { value: 'Domain', component: LinkWithIcon },
						dataDive: { value: '7 Day Stats', valueForFilter: 'Stats', mobileShowMoreOnly: true, component: TableStats },
						graphInfo: { value: '7 Day Graph', valueForFilter: 'Graph', component: TableImage, event: 'clickedGraph', 'clickVars': ['_id'] },
						delete: { value: '', component: TableIcon, event: 'deletePause', hideHeadingMobile: true, mobileClass: ['third'], mobileShowMoreOnly: true, valueForFilter: 'Delete' },
						action: { value: '', alwaysVisible: true, component: TableButton, event: 'goTo', hideHeadingMobile: true, mobileShowMoreOnly: false, hide: false }
					};
				
				case 'rank-tracking' :
					return {
						device: { value: 'Device', component: Device },
						project: { value: 'Project', component: LinkWithIcon },
						searchType: { value: 'Type' },
						url: { value: 'Domain', component: LinkWithIcon },
						rankCaddyScore: { value: 'Caddy Score', component: RankUpDown, mobileShowMoreOnly: true },
						averageRank: { value: 'Av. Rank', component: RankUpDown  },
						keywordCount: { value: 'Keywords Tracked', component: KeywordCount },
						locationName: { value: 'Location', mobileShowMoreOnly: true },
						languageName: { value: 'Language', emptyCell: "Default", mobileShowMoreOnly: true },
						pause: { value: '', component: TableIcon, event: 'deletePause', hideHeadingMobile: true, mobileClass: ['third'], mobileShowMoreOnly: true, valueForFilter: 'Pause' },
						delete: { value: '', component: TableIcon, event: 'deletePause', hideHeadingMobile: true, mobileClass: ['third'], mobileShowMoreOnly: true, valueForFilter: 'Delete' },
						action: { value: '', alwaysVisible: true, component: TableButton, event: 'goTo', hideHeadingMobile: true, mobileShowMoreOnly: false, hide: false }
					};

			}

		},

	    isAdmin () {

	      let extra = TokenService.getExtraInfo();

	      return extra && extra.access && extra.access === 'admin';

	    },

		isDemo () {

			if ( !this.isAdmin ) return false;

			return !!extra.demo;

		},
		isDataDive () {

			return this.dashboardType === 'data-dive';

		}

	},
	watch: {

		showPaused (val) {

			this.loadProjectsLocal ();

		}

	},
	methods: {

		...mapMutations('general',['updateLoadingText','updateVar']),
		...mapActions('general',['loadProjects','playVideo']),

		clickedGraph(info) {
			this.goToDataDive(info._id);
		},

		goToRankTracking () {

			let rtCount = 0, lastId = null;

			this.projectList.forEach( project => {

				if ( project.hasRankTracking && project.active ) {
					
					rtCount++;
					lastId = project._id;

				}

			});

			if ( rtCount === 1 ) this.$router.push('/rank-tracking/' + lastId);
			else this.$router.push('/rank-tracking');

		},

		goToDataDive (_id) {

			this.$router.push('/data-dive' + (_id ? ( '/' + _id + '/url' ) : ''));

		},

		goTo(info) {

			this.$router.push(info.link);

		},

		newProject ( type ) {

			type = type || this.dashboardType;
			
			let enabled = {
				rankTracking: true,
				dataDive: false,
				contentKeywords: false
			};
			if ( type === 'data-dive' ) {

				enabled = {
					rankTracking: false,
					dataDive: true,
					contentKeywords: false
				};

			}
			
			Vue.set(this, 'enabled', enabled);

			this.showProjectSetup = true;

		},

		setView(view) {

			this.view = view;
			TokenService.saveDashboardView(view);

		},

		setupProjectType (info2) {

			this.updateLoadingText( true );

			ApiService.get( 'projects/' + info2._id )
			.then( function( info ) {

				this.updateLoadingText();

				Vue.set( this, 'setupProjectTypeMeta', { type: info2.theType, projectInfo: info.data } );
				this.showProjectSetup = true;

			}.bind(this))
			.catch( function(err) {}.bind(this));

		},

		setShowVideos () {

			this.updateVar({ varName: 'showVideos', info: true });

		},

		pagination(info) {

			Vue.set( this.table, 'page', info.page );
			this.loadProjectsLocal ();

		},

		searchBox () {

			Vue.set( this.table, 'search', { textSearch: this.searchText } );
			this.search();

		},

		search() {

			Vue.set( this.table, 'page', 1 );
			this.loadProjectsLocal ();

		},

		clearSearch () {

			this.searchText = '';
			this.search();

		},

		closeProjectSetup(info) {
			
			this.showProjectSetup = false;

			this.setupProjectTypeMeta = {
				type: null,
				projectInfo: null
			};

			if ( !!info && !!info.message ) {
				
				this.$snotify.success(info.message, !!info.messageTitle ? info.messageTitle : 'Project');

			}

		},

		duplicate (info) {

			this.copyFrom = info;
			this.showProjectSetup = true;

		},

		deletePause (info) {

			let a = 'delete', a2 = 'Deleting', action = 'delete', uri = "projects/" + info._id, xtra = " & all the associated keywords in Rank Tracking and all Data Dive data (this can't be reversed!)", update = null;

			xtra = info.dashboard === 'rank-tracking' ? ' & all the associated keywords in Rank Tracking' : ' & all Data Dive data';

			let label = info.dashboard === 'rank-tracking' ? info.name : info.domain;

			if ( info.action === 'pause' ) {

				a = 'pause';
				a2 = 'Pausing';
				action = 'put';
				uri = "projects/change-state";
				xtra = "";
				update = { state: 'inactive', _ids: [info._id] };

			}

			if ( info.action === 'un-pause' ) {

				a = 'un-pause';
				a2 = 'Un-Pausing';
				action = 'put';
				uri = "projects/change-state";
				xtra = "";
				update = { state: 'active', _ids: [info._id] };

			}

			if ( action === 'delete' ) {

				uri += '/' + info.dashboard;

			}

			this.$dialog
				.confirm( "Are you sure you want to "+a+" " + label + xtra + "?", { okText: 'Yes please', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText( a2 + " " + info.name + ", one moment..." );

					ApiService[action]( uri, update )
					.then( function( info ) {

						this.updateLoadingText();
						this.loadProjectsLocal ();
						this.loadBreakdown ();

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();
						this.$snotify.error(err.response.data.error, a2+' project');

					}.bind(this));

				}.bind(this))
				.catch(function() {
					

				});

		},

		loadProjectsLocal ( loadingText ) {

			if ( !loadingText ) {
				
				loadingText = this.dashboardType === 'all' ? 'Loading...' : ( this.dashboardType === 'data-dive' ? 'Loading domains...' : 'Loading projects...' );

			}

			if ( this.init ) this.updateLoadingText( loadingText );

			let uri = 'projects', 
				table = 'table',
				page = ( this[table].page && !isNaN( this[table].page ) ) ? this[table].page : 1;

			uri += '?page='+page;

			Vue.set( this[table], 'loading', loadingText !== 'fetching-check' );
			Vue.set( this[table], 'loadingText', loadingText === 'fetching-check' ? '' : loadingText );

			if ( this.dashboardType !== 'all' ) {

				uri += '&dashboard='+this.dashboardType;

			}

			if ( this.searchText ) {

				uri += '&textSearch='+this.searchText;

				this.clearTimeout ();

			}
			else if ( loadingText !== 'fetching-check' ) {

				this.loadProjects({ force: true });

			}

			if ( loadingText !== 'fetching-check' ) this.loadBreakdown ();

			if ( this.dashboardType === 'rank-tracking' && !this.showPaused) {

				uri += '&hide-paused=1';

			}

			ApiService.get( uri )
			.then( function( info ) {

				let fetchMatch = false;

				this.init = false;

				this.projectCount = this.projectCount < info.data.count ? info.data.count : this.projectCount;

				if ( loadingText === 'fetching-check' ) {
					
					fetchMatch = true;

					if ( !!this[table].fetching ) {

						Object.keys( this[table].fetching ).forEach ( function (k) {

							if ( k === 'count' ) return;

							if ( this[table].fetching[k].length !== info.data.fetching[k].length ) fetchMatch = false;

							let symDifference = this[table].fetching[k].filter(x => !info.data.fetching[k].includes(x)).concat(info.data.fetching[k].filter(x => !this[table].fetching[k].includes(x)));

							if ( symDifference.length > 1 ) fetchMatch = false;

						}.bind(this));

					}

				}

				if ( fetchMatch ) {

					Vue.set( this[table], 'fetching', info.data.fetching );

				}
				else {

					Object.keys(info.data).forEach ( function (k) {

						Vue.set( this[table], k, info.data[k] );

					}.bind(this));

					Vue.set( this[table], 'loading', false );

					this.fetched = true;

				}

				if ( info.data.fetching.count > 0 && !this.searchText && this.dashboardType === 'all' ) {

					this.clearTimeout ( table );

					this.reloadTimeout[table] = setTimeout( function () {
						
						this.loadProjectsLocal( 'fetching-check' );

					}.bind(this), 15000 );

				}

				this.updateLoadingText();

			}.bind(this))
			.catch( function(err) {
				this.updateLoadingText();
			}.bind(this));

		},
		clearTimeout ( table ) {

			Object.keys( this.reloadTimeout ).forEach ( function (type) {

				if ( !!table && table !== type ) return;

				if ( this.reloadTimeout[type] ) {

					clearTimeout( this.reloadTimeout[type] );
					this.reloadTimeout[type] = null;

				}

			}.bind(this));

		},
		loadBreakdown () {

			ApiService.get( 'users/breakdown' )
			.then( function( info ) {

				Vue.set( this, 'breakdown', info.data.breakdown );
				Vue.set( this, 'totals', info.data.totals );

			}.bind(this))
			.catch( function(err) {}.bind(this));

		}

	},
	created() {

		let h = window.location.hash.replace('#','');

		//this.view = this.dashboardType === 'all' ? TokenService.getDashboardView() : 'table';
		this.view = 'table';

		switch (h) {

			case 'emailConfirmed' :

				this.$snotify.success('Your email address has been confirmed.','Confirm Email');
				
			break;

			case 'demo' :

				let extra = TokenService.getExtraInfo();

				if ( extra.access && extra.access === 'admin' ) {

					extra.demo = true;

					TokenService.saveExtraInfo(extra);

				}

			break;

		}

		this.userFirstName = TokenService.getFirstName();

		this.loadProjectsLocal ();
		this.loadProjectsLocal (null, true );

	},
	beforeDestroy () {
		
		this.clearTimeout ();

	}
}
</script>
<style lang="less" scoped>
@import './../assets/css/less/_settings.less';
@import './../assets/css/less/_helper.less';
@keyframes bg-pulsate {
    0%   { background-color: rgba(241, 73, 42, 1); }
    50% { background-color: @darkContrast; }
    100%   { background-color: rgba(241, 73, 42, 1); }
}
.paused-switcher {
	margin:8px 0 0  20px !important;;
	display: none !important;;
}
.video-thumb-container {
	margin: 30px auto;
	max-width: 380px;
	h3 {
		text-align: center;
		margin-bottom: 10px;
		cursor: pointer;
	}
	img {
		width: 100%;
		.trans;
		cursor: pointer;
		border: 4px solid transparent;
		border-radius: 5px;
		&:hover {
			border-color: fade(@formDefaultColour, 50%);
		}
	}
}
.dashboard-title {
	margin-bottom: 10px;
}
.search-toggle-view {

	background-color: #fff;
	border-radius:5px;
	padding: 10px;
	margin-top: 20px;

	&.faded {

		.opacity(0);

	}

	.search-toggle-view-search {

		.form-input-search {

			width: 265px;
			display: inline-block;
			margin-right: 5px;

		}

		.mag, .clear {

			margin-top: 20px;

		}

		.mag {

			margin-right: 15px;
			cursor: pointer;
			opacity: 0.5;

			&:hover {

				opacity: 1;

			}

		}

		.clear {

			display: inline-block;
			opacity: 0.75;
			cursor: pointer;

			&:hover {

				opacity: 1;

			}

		}
		
	}

	.search-toggle-view-toggle {

		margin-top: 0;
		text-align: center;

		.svg, svg {

			width: 25px;
			height: 25px;
			margin-right: 15px;
			vertical-align: top;
			fill: @darkContrast;
			opacity: 0.225;
			cursor: pointer;
			.trans;

			&:hover {

				opacity: 1;

			}

			&.selected {

				opacity: 1;
				fill: @formDefaultColour;

			}

		}

		.large-button {
			margin: 0;
		}

		&.hasProjects {

			text-align: right;
			margin-top: 20px;

			.large-button {

				vertical-align: top;
				padding: 3px 10px 2px;

			}

		}
		
	}

}
.doughnut {

	margin-bottom: 0;

}
.opening-overview {
	text-align: center;
}
.number-total-wrap {
	display: inline-block;
	vertical-align: top;
	margin: 10px 10px 0;
}
.opening-panel-header {
	line-height: 1.4em;
	font-size: 6vw;
	padding-right: 14vw;
}

.opening-panel-text {
	line-height: 1.6em;
}

.opening-panel-content {
	position: relative;
	.opening-panel-text {
		padding-right: 14vw;
	}
}
.dashboard-info-img {
	width: 12vw;
    max-width: 100%;
    display: block;
	position: absolute;
	right: 0;
	bottom: 0;
	z-index: 2;
}
.large-button.pulse {
	animation: bg-pulsate 2.5s infinite;
}

.dashboard-action-panels {

	.dashboard-action-panel {

		border: 1px solid fade(@darkContrast, 20%);
		border-radius: 5px;
		padding: 10px;
		margin-bottom: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		text-align: center;
		cursor: pointer;
		.trans;

		&:hover {

			border-color: fade(@darkContrast, 50%);

		}

		.svg-circle-wrapper {

			width: 50px;
			height: 50px;
			border-radius: 50%;
			background-color: @formDefaultColour;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 10px;
			flex-shrink: 0;
			flex-grow: 0;
			svg {
				color: #fff;
			}
		}

		.large-button {
			margin: 0;
		}

	}

}

@media screen and (min-width: 670px) {
	.search-toggle-view {

		.search-toggle-view-search {

			width: calc( 100% - 220px );
			display: inline-block;
			vertical-align: top;

			.form-input-search {

				margin-right: 20px;

			}

			.mag {

				margin-right: 15px;

			}

			.mag, .clear {

				margin-top: 0px;

			}
			
		}

		.search-toggle-view-toggle {

			margin-top: 0;
			vertical-align: top;
			text-align: center;

			&.hasProjects {
				width: 200px;
				margin-top: 7px;
				display: inline-block;
			}
			
		}

		&.has-toggle {

			.search-toggle-view-search {

				width: 63%;

			}

			.search-toggle-view-toggle {

				width: 35%;

			}

		}

	}
}
@media screen and (min-width: 600px) {
	.search-toggle-view {

		.search-toggle-view-search {

			.form-input-search {

				width: 280px;

			}

		}

	}
}
@media screen and (min-width: 768px) {
	.opening-overview {
		text-align: left;
	}
	.number-total-wrap {
		margin: 15px 20px 0;
		&:first-child {
			margin-left: 0;
		}
	}

	.search-toggle-view {

		.paused-switcher {
			display: inline-block !important;;
		}

	}
	.opening-panel-header {
		font-size: 5vw;
		padding-right: 12vw;
	}

	.opening-panel-content {
		.opening-panel-text {
			padding-right: 12vw;
		}
	}
	.dashboard-info-img {
		width: 10vw;
	}
	.dashboard-action-panels {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		gap: 10px;
		.dashboard-action-panel {
			flex: 1 1 calc(33.333% - 14px);
			margin-bottom: 0;
			padding: 10px;
		}
	}
}
@media screen and (min-width: 1024px) {
	.search-toggle-view {

		.search-toggle-view-search {

			.form-input-search {

				margin-right: 10px;

			}

			.mag {

				margin-right: 5px;

			}
			
		}

		.search-toggle-view-toggle {

			.svg {

				margin-right: 5px;

			}

			&.hasProjects {

				.large-button {

					margin-left: 10px;

				}

			}
			
		}

	}
	.opening-panel-header {
		font-size: 40px; 
		padding-right: 12vw; 
	}

	.opening-panel-content {
		position: static;
		.opening-panel-text {
			padding-right: 12vw;
		}
	}
	.dashboard-info-img {
		width: auto;
		height: 185px;
		bottom: auto;
		top:0;
	}
	.dashboard-action-panels {
		gap: 20px;
	}

	.opening-panel-content-inner {
		display: flex;
		align-items: flex-start;
		gap: 30px;
		.opening-panel-text {
			flex-shrink: 0;
			flex-grow: 0;
			margin: 0;
			&.full {
				width: 100%;
				padding-right: 0 !important;
			}
		}
		.opening-overview {
			.number-total-wrap {
				margin: 0 20px 20px 0;
			}
		}
	}
	
}

// Graph Type Buttons Styling
.graph-type-buttons-container {
	margin-bottom: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	
	.graph-type-title {
		margin: 0 0 10px 0;
		font-size: 16px;
		font-weight: @bold;
		color: @darkContrast;
		text-align: center;
	}
	
	.graph-type-buttons {
		display: flex;
		background: #fff;
		border-radius: 8px;
		padding: 4px;
		.panelShadow;
		border: 1px solid @borderColor;
		gap: 2px;
		
		.graph-type-button {
			padding: 8px 16px;
			border-radius: 6px;
			font-size: 14px;
			font-weight: @bold;
			cursor: pointer;
			.trans;
			background: transparent;
			color: @darkContrast;
			position: relative;
			overflow: hidden;
			border: 1px solid transparent;
			min-width: 80px;
			text-align: center;
			
			&:hover {
				background: fade(@formDefaultColour, 8%);
				border-color: fade(@formDefaultColour, 20%);
			}
			
			&.active {
				background: @formDefaultColour;
				color: #fff;
				box-shadow: 0 2px 8px fade(@formDefaultColour, 30%);
				border-color: @formDefaultColour;
				
				&:hover {
					background: @formDefaultColour;
					filter: brightness(1.1);
				}
			}
		}
	}
}

@media screen and (max-width: 767px) {
	.graph-type-buttons-container {
		margin: 0 -10px 20px;
		
		.graph-type-title {
			margin: 0 0 15px 0;
			font-size: 15px;
		}
		
		.graph-type-buttons {
			margin: 0 10px;
			width: calc(100% - 20px);
			padding: 6px;
			gap: 4px;
			
			.graph-type-button {
				flex: 1;
				padding: 12px 8px;
				font-size: 13px;
				min-width: auto;
				font-weight: 600;
				border-radius: 4px;
				
				// Better touch targets
				min-height: 44px;
				display: flex;
				align-items: center;
				justify-content: center;
				
				// Improve active state visibility on mobile
				&.active {
					box-shadow: 0 1px 4px fade(@formDefaultColour, 40%);
				}
			}
		}
	}
}

// Additional mobile improvements for very small screens
@media screen and (max-width: 660px) {
	.graph-type-buttons-container {
		.graph-type-buttons {
			flex-direction: column;
			gap: 6px;
			
			.graph-type-button {
				width: 100%;
				padding: 14px 12px;
				font-size: 14px;
				min-height: 48px;
			}
		}
	}
}
@media screen and (min-width: 1440px) {
	.opening-panel-content-inner {
		gap: 50px;
	}
	.opening-panel-text {
		&.full {
			width: 100%;
			padding-right: 0 !important;
		}
	}
	.number-total-wrap {
		margin-top: 0;
		&.small-lr {
			margin-left: 10px;
			margin-right: 10px;
		}
	}
	.fullMenu {
		.opening-overview {
			width: 696px;
		}
		.number-total-wrap {
			&.small-lr {
				margin-left: 6px;
				margin-right: 6px;
			}
		}
	}
}
</style>